<template>
    <ul class="submenu-sections">
        <router-link tag="li" :to="{name:'BoxList', params:{ boxType:Constants.trackTypes.MUSIC.key}}">
            <a>
                <h4>
                    <span class="text">{{ Translations.boxTypeFilters.all }}</span>
                </h4>
            </a>
        </router-link>
        <router-link tag="li" :to="{name:'BoxList', params:{boxType:Constants.trackTypes.MUSIC.key},  query:{ smartBox:false, box:true }}">
            <a>
                <h4>
                    <span class="text">{{ Translations.boxTypeFilters.musicBoxes }}</span>
                </h4>
            </a>
        </router-link>
        <router-link tag="li" :to="{name:'BoxList', params:{boxType:Constants.trackTypes.MUSIC.key},  query:{ smartBox:true, box:false }}">
            <a>
                <h4>
                    <span class="text">{{ Translations.boxTypeFilters.smartBoxes }}</span>

                </h4>
            </a>
        </router-link>
        <template>
<!--          <Button @click.prevent="onBoxExportZipContent" style="width:153.23px!important;height:32px!important;margin:auto 0 auto auto!important; padding-left:9px;padding-right:9px; margin-right: 10px  ">-->
<!--            <template v-if="!spinner">-->
<!--              <span > {{ Translations.buttons.exportZipContent }} </span>-->
<!--            </template>-->
<!--            <template v-if="spinner">-->
<!--              <span > <i class="fas fa-spinner fa-lg fa-spin"></i> </span>-->
<!--            </template>-->
<!--          </Button>-->

            <Button @click.prevent="onBoxExportContent" style="width:153.23px!important;height:32px!important;margin:auto 0 auto auto!important; padding-left:9px;padding-right:9px  ">
                <template v-if="!spinner">
                   <span > {{ Translations.buttons.exportContent }}</span>
                </template>
                <template v-if="spinner">
                   <span > <i class="fas fa-spinner fa-lg fa-spin"></i> </span>
                </template>
            </Button>
        </template>

    </ul>
</template>

<script>
    import Constants from '@/store/constants';
    import Translations from '@/store/translations';
    import router from '@/router';
    import Vue from 'vue';
    import { HTTP } from "@/utils/http";

    export default {
        name: "MusicSectionMenu",
        router,
        data() {
            return {
                spinner: false,
            }
        },
        created(){
                 this.spinner = false;
                },
        methods: {
            onBoxExportContent() {
                if(this.spinner === false) {
                    this.spinner = true;
                    console.log(this.spinner)
                    HTTP.get("/api/station/"+location.pathname.split('/')[1]+"/export-data-csv")
                            .then(response => {
                            console.log(response);
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute("download", "playlist.csv");
                            document.body.appendChild(link);
                            link.click();
                            link.parentNode.removeChild(link);
                            }).then(this.updateSpinner).catch(this.updateSpinner);
                }
     
             },
             updateSpinner() {
                console.log('updateSpinner', this.spinner)
                this.spinner = false; 
             }
        },
        computed: {
            Translations: () => Translations,
            Constants: () => Constants,
        }
    }
</script>

<style scoped>

</style>
